import { render, staticRenderFns } from "./_testimonies.vue?vue&type=template&id=f38a6d52&"
import script from "./_testimonies.vue?vue&type=script&lang=js&"
export * from "./_testimonies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports